import { toast } from "react-toastify";

export default () => toast("event successfully updated", { autoClose: 3000 });
